import { FileProcessingResult } from './types/FileProcessingResult';

export const defaultForm =   {
  productName: 'CLARITY SMTH',
  brandName: 'Walmart',
  gtin: '081542101803',
  purchaseValidation: true,
};

export const defaultResp: FileProcessingResult = {
  "handle-id": "8f6e069d-695e-490e-a256-0e48948b6b8b",
  "capture": {
    "client-code": "DM",
    "client-handle-id": "f5665eeb239887600384bcee7ad6649c",
    "client-user-id": "774812ab9ff76b907e68c233d9fe4a53",
    "country": "US",
    "transcription-method": "AUTOMATIC",
    "snapshots": [
      {
        "url": "https://s3.amazonaws.com/ourcart.platform.snapshots.staging/demo/f5665eeb239887600384bcee7ad6649c_1.jpg"
      }
    ],
    "products-of-interest": [
      {
        "gtin": "0853687004706",
        "title": "clarity smth",
        "brand": "walmart"
      }
    ]
  },
  "receipt": {
    "retailer-name": "WALMART",
    "address": "GAINESVILLE fl 32608",
    "store": {
      "city": "GAINESVILLE",
      "zip": "32608",
      "state": "FL"
    },
    "purchase-date": "2023-12-30",
    "purchase-time": "17:20:52",
    "total": {
      "amount": 15.91,
      "currency": "USD"
    },
    "discounts": {
      "text": "Total discounts",
      "total": -10.05
    },
    "items": [
      {
        "code": "085671600815",
        "text": "STRAWBERRY",
        "total": {
          "amount": 5.97,
          "currency": "USD"
        },
        "price": {
          "amount": 5.97,
          "currency": "USD"
        },
        "quantity": {
          "value": 1.0,
          "unit": "one"
        },
        "type": "item"
      },
      {
        "code": "085671600815",
        "text": "STRAWBERRY",
        "total": {
          "amount": 5.97,
          "currency": "USD"
        },
        "price": {
          "amount": 5.97,
          "currency": "USD"
        },
        "quantity": {
          "value": 1.0,
          "unit": "one"
        },
        "type": "item"
      },
      {
        "text": "COUPON 16008 051600800000 F",
        "total": {
          "amount": -5.97,
          "currency": "USD"
        },
        "price": {
          "amount": -5.97,
          "currency": "USD"
        },
        "quantity": {
          "value": 1,
          "unit": "one"
        },
        "type": "discount"
      },
      {
        "code": "085556911060",
        "text": "DCCPB PERFE",
        "total": {
          "amount": 2.48,
          "currency": "USD"
        },
        "price": {
          "amount": 2.48,
          "currency": "USD"
        },
        "quantity": {
          "value": 1.0,
          "unit": "one"
        },
        "type": "item"
      },
      {
        "code": "085556911060",
        "text": "DCCPB PERFE",
        "total": {
          "amount": 2.48,
          "currency": "USD"
        },
        "price": {
          "amount": 2.48,
          "currency": "USD"
        },
        "quantity": {
          "value": 1.0,
          "unit": "one"
        },
        "type": "item"
      },
      {
        "code": "085368700470",
        "text": "CLARITY SMTH",
        "total": {
          "amount": 4.98,
          "currency": "USD"
        },
        "price": {
          "amount": 4.98,
          "currency": "USD"
        },
        "quantity": {
          "value": 1.0,
          "unit": "one"
        },
        "product-of-interest": true,
        "product": {
          "gtin": "0853687004706",
          "title": "clarity smth",
          "brand": "walmart"
        },
        "type": "item"
      },
      {
        "code": "081542101803",
        "text": "JOVVEGANMAC",
        "total": {
          "amount": 4.08,
          "currency": "USD"
        },
        "price": {
          "amount": 4.08,
          "currency": "USD"
        },
        "quantity": {
          "value": 1.0,
          "unit": "one"
        },
        "product-of-interest": false,
        "product": {
          "gtin": "0815421018035",
          "title": "clarity smth",
          "brand": "walmart"
        },
        "type": "item"
      },
      {
        "text": "COUPON 42101 054210100000 A",
        "total": {
          "amount": -4.08,
          "currency": "USD"
        },
        "price": {
          "amount": -4.08,
          "currency": "USD"
        },
        "quantity": {
          "value": 1,
          "unit": "one"
        },
        "type": "discount"
      }
    ],
    "phone": "3523713171"
  },
  "requested-on": "2024-01-18T15:32:48.713Z",
  "consumed-on": "2024-01-18T15:32:48.754655Z",
  "completed-on": "2024-01-18T15:32:54.983100Z",
  "attempted-transcription-method": "AUTOMATIC"
};
